import React from 'react';
import { getActivityType } from '../services/utils';

import './ActivityLabel.css';

interface ActivityLabelProps  {
    activityTypeId: number;
}
  
  const ActivityLabel: React.FC<ActivityLabelProps> = ({ activityTypeId }) => {
    let activityType = getActivityType(activityTypeId);
    let activitLabelClass = "my_activityLabel_" + activityTypeId;
    
    return (
        <div className={activitLabelClass}>
           {activityType}
        </div>
    );
  };
  
  export default ActivityLabel;